export default "__VITE_ASSET__CDkmy2Vp__"